import React from 'react';
import { BarChart } from 'lucide-react';

export default function EmptyAnalyticsState({ 
  title = "No analytics data available", 
  message = "There is no activity recorded for this period yet. Data will appear once conversations are logged." 
}) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[340px] w-full p-8 text-center">
      <div className="w-12 h-12 rounded-xl bg-zinc-100 border border-zinc-200 flex items-center justify-center text-zinc-500 mb-3.5">
        <BarChart size={22} strokeWidth={1.75} />
      </div>
      <h3 className="text-sm sm:text-base font-bold text-zinc-900 tracking-tight mb-1">
        {title}
      </h3>
      <p className="text-xs text-zinc-500 max-w-sm leading-relaxed">
        {message}
      </p>
    </div>
  );
}
